import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  category: {
    id: '',
    name: '',
    type: '',
  },
  album: {
    id: '',
    name: '',
    type: '',
  },
  message: '',
}

const albumsSlice = createSlice({
  name: 'albums',
  initialState,
  reducers: {
    setCategory: (state, action) => {
      state.category = action.payload || initialState.category
    },
    setMessage: (state, action) => {
      state.message = action.payload || initialState.message
    },
    setAlbum: (state, action) => {
      state.album = action.payload || initialState.album
    },
  },
})

export const { setCategory, setMessage, setAlbum } = albumsSlice.actions

export default albumsSlice
